export enum TimeType {
    fullTime = 40,
    partTime = 20,
}

export interface ParentStudyViewModel {
    code: string;
    timeType: TimeType;
}
